'use client';
import { useEffect, useState } from 'react';

/**
 * Reads the `commentId` query param produced by a review deep-link
 * (overwolfstore://app/<uid>/reviews/<id> → /app/<seo>?commentId=<id>#reviews).
 *
 * Read once on mount from window.location to avoid the Suspense boundary that
 * next/navigation's useSearchParams requires; returns the numeric comment id
 * (matching Review.comment_ID) or null when absent/invalid.
 */
export const useCommentDeepLink = (): number | null => {
  const [commentId, setCommentId] = useState<number | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const raw = new URLSearchParams(window.location.search).get('commentId');
    if (!raw) return;

    const parsed = Number(raw);
    if (Number.isInteger(parsed) && parsed > 0) {
      setCommentId(parsed);
    }
  }, []);

  return commentId;
};
